"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var Types = require("types");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var sok_ui_1 = require("@caddigital/sok-ui");
var filesActions = require("@caddigital/sok-reducers/lib/actions/files");
var filesReducer = require("@caddigital/sok-reducers/lib/reducers/files");
var FileMoveOverlay_1 = require("components/sidemenus/FileMoveOverlay");
var ImportFromProjectOverlay_1 = require("components/sidemenus/ImportFromProjectOverlay");
var RevisionList_1 = require("views/RevisionList");
var FileListOverview_1 = require("views/FileListOverview");
var FilesPreviewView_1 = require("views/FilesPreviewView");
var MetadataEditorView_1 = require("views/MetadataEditorView");
var FilesCompareView_1 = require("views/FilesCompareView");
require("./style.scss");
var mapStateToProps = function (state) { return ({
    currentFolder: state.files.currentFolder,
    sortByOptions: state.files.sortByOptions,
    searchOptions: state.files.searchOptions
}); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchSchema: function (id) {
        return dispatch(filesActions.fetchSchema(id, {
            includeSubSchemas: 'true'
        }));
    },
    fetchFolder: function (folderId, sortByOptions, searchOptions, queryParamets) {
        return dispatch(filesActions.fetchFiles(folderId, sortByOptions, searchOptions, queryParamets));
    },
    fethProjectFilelistColumns: function (project) {
        return dispatch(filesActions.fetchFileListColumns(project.id));
    },
    clearTree: function () { return dispatch(filesActions.FileBrowserActions.clear()); },
    initFileBrowser: function (useFolderTree, root) {
        if (useFolderTree && root) {
            dispatch(filesActions.initFolderTree(true, root));
        }
        else {
            dispatch(filesActions.initFolderTree(false));
        }
    },
    fetchFilelistWidth: function (project) {
        return dispatch(filesActions.getFilelistWidthRequestAction(project));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        if (!this.props.match.params.folderId) {
            return;
        }
        if (this.props.showFolderTree &&
            this.props.rootFolder &&
            this.props.currentProject &&
            this.props.currentProject.rootFolder === this.props.rootFolder.id &&
            this.props.rootFolder.type === 'FOLDER') {
            this.props.initFileBrowser(true, this.props.rootFolder);
            this.props.fetchFilelistWidth(this.props.currentProject.id);
        }
        else if (!this.props.showFolderTree && this.props.rootFolder) {
            this.props.initFileBrowser(false);
        }
        var folderId = parseInt(this.props.match.params.folderId, 10);
        this.props.fetchFolder(folderId, __assign({}, filesReducer.initialSortByOptions), __assign({}, filesReducer.defaultFileSearchOptions), this.props.showFolderTree
            ? { markAutomaticOrderFolders: 'true' }
            : undefined);
        this.props.fetchSchema(folderId);
        if (this.props.currentProject) {
            this.props.fethProjectFilelistColumns(this.props.currentProject);
        }
    },
    componentWillReceiveProps: function (nextProps) {
        var folderId = parseInt(nextProps.match.params.folderId, 10);
        var softReload = this.props.location.key !== nextProps.location.key &&
            this.props.location.pathname === nextProps.location.pathname;
        if (this.props.location.pathname !== nextProps.location.pathname ||
            softReload) {
            if (this.props.currentFolder === null ||
                folderId !== this.props.currentFolder.id) {
                var cm = nextProps.metadata.list.find(function (x) { return x.identifier === 'name-meta'; });
                // it is safe for us to preserve 'toggleHideEmptyFolders' because
                // we're also invoking 'fetchFolder' if the entire 'searchOptions'
                // changes in the else if below.
                var nextSearchOptions = __assign(__assign({}, filesReducer.defaultFileSearchOptions), { toggleHideEmptyFolders: this.props.searchOptions.toggleHideEmptyFolders });
                nextProps.fetchFolder(folderId, __assign(__assign({}, filesReducer.initialSortByOptions), { sortBy: (cm && cm.id) || 0 }), nextSearchOptions, this.props.showFolderTree
                    ? { markAutomaticOrderFolders: 'true' }
                    : undefined);
                if (nextProps.metadata.status !== 'FETCHING' &&
                    nextProps.metadata.status !== 'FETCHED') {
                    this.props.fetchSchema(folderId);
                }
                if (nextProps.metadata.status === 'FETCHED' &&
                    nextProps.currentFolder &&
                    this.props.currentFolder &&
                    nextProps.currentFolder.project !== this.props.currentFolder.project) {
                    this.props.fetchSchema(folderId);
                    if (this.props.currentProject) {
                        this.props.fethProjectFilelistColumns(this.props.currentProject);
                    }
                }
            }
            else {
                nextProps.fetchFolder(folderId, nextProps.sortByOptions, nextProps.searchOptions, this.props.showFolderTree
                    ? { markAutomaticOrderFolders: 'true' }
                    : undefined);
            }
        }
        else if (JSON.stringify(__assign(__assign({}, this.props.searchOptions), { toggleHideEmptyFolders: false })) !==
            JSON.stringify(__assign(__assign({}, nextProps.searchOptions), { toggleHideEmptyFolders: false }))) {
            nextProps.fetchFolder(folderId, nextProps.sortByOptions, nextProps.searchOptions, this.props.showFolderTree
                ? { markAutomaticOrderFolders: 'true' }
                : undefined);
        }
        if (nextProps.showFolderTree &&
            this.props.rootFolder !== nextProps.rootFolder &&
            nextProps.currentProject &&
            nextProps.rootFolder &&
            nextProps.rootFolder.type === 'FOLDER' &&
            nextProps.rootFolder.id === nextProps.currentProject.rootFolder) {
            this.props.initFileBrowser(true, nextProps.rootFolder);
            this.props.fetchFilelistWidth(nextProps.currentProject.id);
        }
        else if (!nextProps.showFolderTree &&
            this.props.rootFolder !== nextProps.rootFolder) {
            this.props.initFileBrowser(false);
        }
    },
    componentWillUnmount: function () {
        this.props.clearTree();
    }
}), recompose_1.pure);
var Loading = function () { return (React.createElement("div", { className: 'files-router-loading' },
    React.createElement(sok_ui_1.LoadingSpinner, null))); };
exports.default = enhance(function (routerProps) {
    var metadata = routerProps.metadata;
    var currentProject = routerProps.currentProject;
    var currentFolder = routerProps.currentFolder;
    var rootFolder = routerProps.rootFolder;
    var baseUrl = routerProps.match.path;
    var currentBid = routerProps.currentBid;
    var showFolderTree = routerProps.showFolderTree;
    var currentBriefcase = routerProps.currentBriefcase;
    var perm = routerProps.currentProject
        ? routerProps.currentProject.perm
        : 0x00;
    return (React.createElement(React.Fragment, null,
        React.createElement(react_router_dom_1.Switch, null,
            React.createElement(react_router_dom_1.Route, { key: 'metadata', path: baseUrl + "/metadata/:sessionUuid?", render: function (props) { return (React.createElement(MetadataEditorView_1.default, __assign({}, props, { BreadCrumb: routerProps.BreadCrumb, metadata: metadata, currentBid: currentBid, currentBriefcase: currentBriefcase, currentProject: currentProject, sessionUuid: props.match.params.sessionUuid }))); } }),
            React.createElement(react_router_dom_1.Route, { exact: true, key: 'files_with_folder', path: baseUrl, render: function (props) {
                    return rootFolder ? (React.createElement(FileListOverview_1.default, __assign({}, props, { disableDragAndDrop: routerProps.appendUploadFiles === undefined, folderId: parseInt(routerProps.match.params.folderId, 10), BreadCrumb: routerProps.BreadCrumb, Tools: routerProps.Tools, staticIconCount: routerProps.staticIconCount, staticIconCountMobile: routerProps.staticIconCountMobile, ViewHeader: routerProps.ViewHeader, ListHeader: routerProps.ListHeader, ListRow: routerProps.ListRow, toggleUploadModal: routerProps.toggleUploadModal, appendUploadFiles: routerProps.appendUploadFiles, metadata: metadata, rootFolder: rootFolder, currentProject: currentProject, baseUrl: props.match.url, currentBriefcase: currentBriefcase, currentBid: currentBid, showFolderTree: showFolderTree }))) : (React.createElement("div", null));
                } }),
            !currentBid && (React.createElement(react_router_dom_1.Route, { exact: true, key: 'revisions', path: baseUrl + "/revisions/:fileId", render: function (props) { return (React.createElement(RevisionList_1.default, __assign({}, props, { BreadCrumb: routerProps.BreadCrumb, rootFolder: rootFolder ? rootFolder.id : NaN, currentFolder: currentFolder, currentProject: currentProject, baseUrl: props.match.url }))); } })),
            currentProject &&
                (perm & acl.VIEWER_2D_PERM || perm & acl.PDFCOMPARE_PERM) && (React.createElement(react_router_dom_1.Route, { exact: true, key: 'compare', path: baseUrl + "/compare/:beforeRevisionUuid/:afterRevisionUuid", render: function (props) {
                    return currentFolder ? (React.createElement(FilesCompareView_1.default, __assign({}, props, { BreadCrumb: routerProps.BreadCrumb, currentProject: currentProject, currentFolder: currentFolder, baseUrl: props.match.url }))) : (React.createElement(Loading, null));
                } })),
            React.createElement(react_router_dom_1.Route, { path: baseUrl + "/preview/:fileUUID/revision/:revisionUuid/", key: 'preview', render: function (props) {
                    return currentFolder ? (React.createElement(FilesPreviewView_1.default, __assign({}, props, { BreadCrumb: routerProps.BreadCrumb, currentFolder: currentFolder, currentProject: currentProject, currentBid: currentBid, currentBriefcase: currentBriefcase, rootFolder: rootFolder ? rootFolder.id : NaN, baseUrl: props.match.url }))) : (React.createElement(Loading, null));
                } }),
            React.createElement(react_router_dom_1.Route, { path: baseUrl + "/preview/:fileUUID", key: 'preview', render: function (props) {
                    return currentFolder ? (React.createElement(FilesPreviewView_1.default, __assign({}, props, { BreadCrumb: routerProps.BreadCrumb, currentFolder: currentFolder, currentProject: currentProject, currentBid: currentBid, currentBriefcase: currentBriefcase, rootFolder: rootFolder ? rootFolder.id : NaN, baseUrl: props.match.url }))) : (React.createElement(Loading, null));
                } }),
            React.createElement(react_router_dom_1.Redirect, { key: 'redirect', to: routerProps.match.url })),
        React.createElement(FileMoveOverlay_1.FileMoveOverlay, { rootFolder: rootFolder, key: 'move-copy' }),
        !currentBid && currentFolder && (React.createElement(ImportFromProjectOverlay_1.ImportFromProjectOverlay, { targetFolder: currentFolder, key: 'import-from-project' }))));
});
